import { Directive, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { AuthFormState, SetAuthFormEmail } from '@platform-frontend/account';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[yatAuthFormEmail]'
})
export class AuthFormEmailDirective implements OnInit, OnDestroy {
  constructor(protected store: Store) {}

  email$: Observable<string> = this.store.select(AuthFormState.email);
  emailControl = new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.email] });

  ngOnInit(): void {
    this.email$
      .pipe(
        tap(email => this.emailControl?.setValue(email)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.store.dispatch(new SetAuthFormEmail(this.emailControl?.value));
  }
}
